/**
 * The Admin Ultimate Design on a React-Bootstrap modal (SSD-7441). These modals are portalled to <body>, outside the
 * screen's `.wms-wireframe.ff-ultimate` root, so they opt in by class; ultimateDesign.css styles `.ff-ultimate-modal`
 * and its backdrop the way it styles the screen's own dialogs. A modal without these classes keeps Bootstrap's look.
 */
export const ULTIMATE_MODAL = { className: 'ff-ultimate-modal', backdropClassName: 'ff-ultimate-backdrop' } as const;
